import styled from "styled-components";
import React from "react";

const DetailCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 31, 82, 0.1);
  margin-bottom: 1.5rem;
  border-left: 4px solid #64da4c;
  transition: background 0.3s ease, box-shadow 0.3s ease;

  .dark-mode & {
    background: #2a2a3e;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const DetailRow = styled.div`
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
  transition: border-color 0.3s ease;
  
  .dark-mode & {
    border-bottom-color: #3a3a4e;
  }
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

const Label = styled.div`
  font-weight: 600;
  color: #001f52;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #64da4c;
  }
`;

const Value = styled.div`
  color: #333;
  font-size: 1rem;
  line-height: 1.6;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #d0d0d0;
  }
`;

interface DetailItem {
  label: string;
  value: string | number;
}

interface Props {
  title?: string;
  details: DetailItem[];
}

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #001f52;
  font-size: 1.5rem;
  font-weight: 700;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #e0e0e0;
  }
`;

export default function DetailBox({ title, details }: Props) {
  return (
    <DetailCard>
      {title && <Title>{title}</Title>}
      {details.map((detail, index) => (
        <DetailRow key={index}>
          <Label>{detail.label}</Label>
          <Value>{detail.value}</Value>
        </DetailRow>
      ))}
    </DetailCard>
  );
}